<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">分仓配送时效维护</h3>

    <div class="form-container">
      <div class="tools" style="margin-bottom: 10px">
        <form-button name="保存" @click="saveData" />
        <form-button name="提交" @click="saveData" />
        <form-button v-if="mode === 'edit'" name="返回" @click="$router.go(-1)" />
      </div>
      <el-form ref="form" inline size="mini" :show-message="false" label-width="100px" :model="conditions" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="导入时间">
              <el-input
                v-model="conditions.importedDate"
                placeholder="自动生成"
                disabled
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <!--操作人是登录用户-->
            <el-form-item label="操作人">
              <el-select
                v-model="conditions.createdByName"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="启运城市">
              <el-select
                v-model="conditions.fromcity"
              >
                <el-option
                  v-for="item in selectDataOptions['startCity']"
                  :key="item.CITY_CODE"
                  :value="item.CITY_CODE"
                  :label="item.CITY_NAME"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省">
              <el-select
                v-model="conditions.province"
                @change="provinceChange"
              >
                <el-option
                  v-for="item in selectDataOptions['region']"
                  :key="item.BLAND"
                  :value="item.BLAND"
                  :label="item.BEZEI"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="市">
              <el-select
                v-model="conditions.city"
                @change="cityChange"
              >
                <el-option
                  v-for="item in selectDataOptions['city']"
                  :key="item.CITY_CODE"
                  :value="item.CITY_CODE"
                  :label="item.CITY_NAME"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="县">
              <el-select
                v-model="conditions.district"
              >
                <el-option
                  v-for="item in selectDataOptions['street']"
                  :key="item.STRT_CODE"
                  :value="item.STRT_CODE"
                  :label="item.MC_STREET"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备货时效(H)">
              <el-input
                v-model="conditions.readyTime"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="运输时效(H)">
              <el-input
                v-model="conditions.transportionTime"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="生效日期">
              <el-date-picker
                v-model="conditions.validate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="100件以下中转时效(H)">
              <el-input
                v-model="conditions.transferTimeUnder100"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.comment"
                type="textarea"
                rows="3"
              />
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
  </div>
</template>
<script>
import { getArea } from '@/api/sap/common-sap'
import { apiLogisticSagingUpdate, apiLogisticSagingFindById } from '@/api/applyForGoods/logisticsAbnormal'

export default {
  name: 'DeliverySettingList',
  data() {
    return {
      conditions: {
        fromcity: '',
        province: '',
        city: '',
        district: '',
        validateStart: '',
        validateEnd: '',
        importedDateStart: '',
        importedDateEnd: '',
        validate:'',
        status: 0,
        createdByName: ''
      },
      mode: 'add',
      selectDataOptions: {
        startCity: [],
        region: [],
        city: [],
        street: []
      },
      loading: false
    }
  },
  created() {
    if (this.$route.query.id) {
      this.mode = 'edit'
      this.queryDetail(this.$route.query.id)
    }
    // 初始化省份
    getArea().then(res => {
      this.selectDataOptions['region'] = res.DATA
    })
    // 初始化起运城市
    getArea('', 'city', 1).then(res => {
      this.selectDataOptions['startCity'] = res.DATA
    })
  },
  methods: {
    async queryDetail(id) {
      const { data } = await apiLogisticSagingFindById({ id })
      Object.assign(this.conditions, data)
    },
    async saveData() {
      const params = {
        ...this.conditions
      }
      const { status, data, msg } = await apiLogisticSagingUpdate(params)
      if (status !== 1) {
        this.$message.error(msg)
      }
      this.$message.success('操作成功！')
      Object.assign(this.conditions, data)
    },
    provinceChange(e) {
      if (!e) return
      // 查询市
      getArea(e, 'city').then(res => {
        this.selectDataOptions['city'] = res.DATA
      })
      this.conditions.city = ''
      this.conditions.district = ''
      this.selectDataOptions['street'] = []
    },
    cityChange(e) {
      if (!e) return
      // 查询县
      getArea(e, 'street').then(res => {
        this.selectDataOptions['street'] = res.DATA
      })
      this.conditions.district = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/warehouseLogisticsTimelinessMaintain.vue